(function($) {
    "use strict";

    var collapse = $.fn.collapse.Constructor.prototype;

    $.fn.collapse.Constructor.prototype = $.extend({}, collapse, {

        stopTransitioning: function() {
            this.transitioning = 0;
        },

        /**
         * Remove "collapsed" class on toggle link of the element to be shown
         */
        show: function() {
            var self = this;

            if (this.$element.hasClass("in")) {
                return;
            }

            collapse.show.call(this);

            $(this.$element).each(function(index, item) {
                self._findToggleElements(item).removeClass('collapsed');
            });
        },

        /**
         * Add the "collapsed" class on toggle link of the element to be hidden
         */
        hide: function() {
            var self = this;

            if (!this.$element.hasClass("in")) {
                return;
            }

            collapse.hide.call(this);

            $(this.$element).each(function(index, item) {
                self._findToggleElements(item).addClass('collapsed');
            });
        },

        transition: function (method, startEvent, completeEvent) {
            var self = this,
                complete = function () {
                    if (startEvent.type === 'show') {
                        self.reset();
                    }
                    self.transitioning = 0;
                    self.$element.trigger(completeEvent);
                };

            this.$element.trigger(startEvent);

            if (startEvent.isDefaultPrevented()) {
                return;
            }

            this.transitioning = 1;

            this.$element[method]('in');

            $.support.transition && this.$element.hasClass('collapse') && !self.$element.hasClass("hidden") ?
                this.$element.one($.support.transition.end, complete) :
                complete();
        },

        _findToggleElements: function(item) {
            return $(
                [
                    '[data-toggle="collapse"][href="#' + item.id + '"]',
                    '[data-toggle="collapse"][data-target="#' + item.id + '"]'
                ].join(",")
            );
        }
    });

    $(document).off('click.collapse.data-api');

    $(document).on('click.collapse.data-api', '[data-toggle=collapse]', function (e) {
        var $this = $(this),
            option,
            target;

        if ($this.hasClass("disabled")) {
            e.preventDefault();
            return;
        }

        target = $this.attr('data-target');
        if (!target) {
            e.preventDefault();
            target = $this.attr('href');
            target.replace(/.*(?=#[^\s]+$)/, '');
        }

        target = $(target);
        option = target.data('collapse') ? 'toggle' : $this.data();
        $this[target.hasClass('in') ? 'addClass' : 'removeClass']('collapsed');
        target.collapse(option);
    });

}(window.jQuery));
